#import "../fragments/queued-email-fragment.graphql"

mutation EditQueuedEmail($payload: EditQueuedEmailInput!) {
    editQueuedEmail(input: $payload) {
        emailsQueued {
            ...QueuedEmail
        }
    }
}
